module.exports = __webpack_public_path__ + "img/logo-cabecera-hubgrade.509f40cf.svg";